(function () {
  const megaMenus =
    document.currentScript.parentElement.querySelectorAll(".mega");
  const triggers = document.currentScript.parentElement.querySelectorAll(
    "[data-has-children]"
  );
  const stickyHeader = document.querySelector(".section-header");
  const mobileCloseBtns = document.querySelectorAll(".menu-drawer__close");
  const mobileMenu = document.querySelector("#Details-menu-drawer-container");

  megaMenus.forEach((menu) => {
    menu.addEventListener("click", (e) => {
      if (!e.target.closest(".mega-menu__list")) {
        close(menu);
      }
    });
  });

  mobileCloseBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      mobileMenu.classList.remove("menu-opening");

      mobileMenu.querySelector("summary").setAttribute("aria-expanded", false);
      document.querySelector("body").classList.remove("overflow-hidden-tablet");

      setTimeout(function () {
        stickyHeader.classList.remove("menu-open");
      }, 200);
    });
  });

  function close(menu) {
    menu.classList.remove("active");
    menu.style.transition = "0s";
    stickyHeader.classList.remove("menu-open");
    document.querySelector("body").classList.remove("overflow-hidden");
  }

  function open(menu) {
    menu.style.transition = "0.6s";
    menu.classList.add("active");
    stickyHeader.classList.add("menu-open");
    document.querySelector("body").classList.add("overflow-hidden");
  }

  triggers.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      const btnId = btn.getAttribute("data-has-children");

      megaMenus.forEach((menu) => {
        const menuId = menu.getAttribute("data-id");

        if (menuId == btnId) {
          if (menu.classList.contains("active")) {
            close(menu);
          } else {
            open(menu);
          }
        }
      });
    });
  });
})();
